import * as Yup from "yup";

import { DiscountTypeEnum } from "../enums";

export const DEFAULT_VALUES = {
  promotionCampaign: null,
  name: "",
  promotionType: "",
  discountType: DiscountTypeEnum.PERCENTAGE,
  discountAmount: "",
  maximumDiscountAmount: "",
  validFrom: null,
  validTo: null,
  status: "",
  globalUsageLimit: "",
  perCustomerLimit: "",
  outlets: {},
};

export const VALIDATION_SCHEMA = Yup.object().shape({
  promotionCampaign: Yup.object().required("Harus diisi"),
  name: Yup.string().required("Harus diisi"),
  promotionType: Yup.string().required("Harus diisi"),
  discountAmount: Yup.number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? undefined : value
    )
    .min(0, "Tidak boleh negatif")
    .when("discountType", {
      is: DiscountTypeEnum.PERCENTAGE,
      then: (schema) => schema.max(100, "Maksimal 100%"),
    })
    .required("Harus diisi"),
  // Optional cap for percentage promotions only; empty means no maximum.
  maximumDiscountAmount: Yup.number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    )
    .nullable()
    .when("discountType", {
      is: DiscountTypeEnum.PERCENTAGE,
      then: (schema) =>
        schema.integer("Tidak boleh desimal").min(1, "Minimal 1"),
    }),
  validFrom: Yup.date().required("Harus diisi").typeError("Tanggal tidak valid"),
  validTo: Yup.date()
    .required("Harus diisi")
    .typeError("Tanggal tidak valid")
    .min(Yup.ref("validFrom"), "Harus setelah tanggal mulai"),
  status: Yup.string().required("Harus diisi"),
  globalUsageLimit: Yup.number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? undefined : value
    )
    .required("Harus diisi"),
  perCustomerLimit: Yup.number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    )
    .nullable(),
});
